import { useAppSelector } from 'hooks/reduxHooks'

const CART_BETA_USER_IDS: ReadonlySet<string> = new Set([
  '274d4798-9e4d-4770-a644-4bbe0e04cab2',
  '15efccbc-a741-4dc4-8d3d-a86de738e941',
  'a2f8436d-5de0-4475-ba3b-9f7586095646',
  '531a988d-493c-42d9-a207-be00c448af9b',
  '309bbbeb-24c1-4929-becd-4e5e67c2b1d9',
  '942cc1f1-5481-4a28-b151-16fa6f928ec1',
  '5f34d7cb-3945-44f5-a2de-d3dcc828e825',
  '60720175-2221-47b3-ad00-e4d0a4a4f952',
  'd638c4cb-6a26-4088-9c1c-79897d2fbda0',
  '5fa9f9b4-c800-475e-875b-06c96b554992',
  'cf01cdf4-1019-4641-bf97-843fcd8fae15',
  'a311cbf5-16dd-4792-b934-fadcfbf5a107',
  '711f4d43-9387-4883-a6e2-8764f556e930',
  'e678ec18-c11d-4df5-91d2-ad642ae07622',
  '63d2d0ee-28e1-4860-9a35-323583b2f473',
])

export function useIsCartBetaUser(): boolean {
  const memberId = useAppSelector(state => state.auth.account.memberId)
  return !!memberId && CART_BETA_USER_IDS.has(memberId)
}
